import { useRouter } from "next/router";
import { useContext } from "react";
import { UserContext } from "@/context/UserContext";
import {
  FaExclamationTriangle,
  FaClock,
  FaSignInAlt,
  FaRedo,
  FaSignOutAlt
} from "react-icons/fa";
import styles from "./SessionExpiredModal.module.css";

export default function SessionExpiredModal() {
  const router = useRouter();
  const {
    logoutUser,
    user,
    showSessionExpiredModal,
    sessionExpiredReason,
    closeModal,
    handleStayConnected
  } = useContext(UserContext);

  if (!showSessionExpiredModal) {
    return null;
  }

  const handleLogout = async () => {
    closeModal();
    await logoutUser('manual');

    let redirectUrl = '/login';
    if (user?.role === 'hr') {
      redirectUrl = '/login?role=hr';
    } else if (user?.role === 'instructor') {
      redirectUrl = '/login?role=instructor';
    } else if (user?.role === 'admin') {
      redirectUrl = '/login?role=admin';
    }

    router.push(redirectUrl);
  };

  const handleLoginRedirect = () => {
    closeModal();

    let redirectUrl = '/login';
    if (user?.role === 'hr') {
      redirectUrl = '/login?role=hr';
    } else if (user?.role === 'instructor') {
      redirectUrl = '/login?role=instructor';
    } else if (user?.role === 'admin') {
      redirectUrl = '/login?role=admin';
    }

    router.push(redirectUrl);
  };

  const handleStay = () => {
    handleStayConnected();
  };

  // Render content based on reason
  const isTokenExpired = sessionExpiredReason === 'token';

  return (
    <div className={styles.modalOverlay}>
      <div className={`${styles.modalCard} ${isTokenExpired ? styles.variantError : styles.variantInfo}`}>
        <div className={styles.modalHeader}>
          <div className={`${styles.iconWrapper} ${!isTokenExpired ? styles.iconPulse : ''}`}>
            {isTokenExpired ? <FaExclamationTriangle /> : <FaClock />}
          </div>
          <h4 className={styles.modalTitle}>
            {isTokenExpired ? "Session Expired" : "Are You Still There?"}
          </h4>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.modalText}>
            {isTokenExpired
              ? "Your session has expired due to security reasons. Please log in again to continue your session."
              : "You've been inactive for a while. For your security, we'll log you out soon unless you want to stay connected."}
          </p>

          <div className={styles.buttonGroup}>
            {isTokenExpired ? (
              <button
                className={`${styles.btn} ${styles.btnPrimary}`}
                onClick={handleLoginRedirect}
              >
                <FaSignInAlt /> Login Again
              </button>
            ) : (
              <>
                <button
                  className={`${styles.btn} ${styles.btnPrimary}`}
                  onClick={handleStay}
                >
                  <FaRedo /> Stay Connected
                </button>
                <button
                  className={`${styles.btn} ${styles.btnDanger}`}
                  onClick={handleLogout}
                >
                  <FaSignOutAlt /> Logout
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}